var map = {
	"./bao.png": "6a04",
	"./beverages.png": "25f8",
	"./can.png": "6714",
	"./caviar.png": "43a7",
	"./chopsticks.png": "a55f",
	"./clam.png": "9c34",
	"./crab.png": "ceca",
	"./cutlet.png": "df4c",
	"./delicacies-2.png": "eb4b",
	"./delicacies.png": "35c0",
	"./disposable-items.png": "2fe7",
	"./dumplings.png": "92d7",
	"./ebi-and-sushi-toppings.png": "ce7e",
	"./edamame.png": "83f1",
	"./fish-2.png": "7e1f",
	"./fish-3.png": "8202",
	"./fish-filet-2.png": "1895",
	"./fish-filet.png": "c42c",
	"./fish-frozen.png": "1e27",
	"./fish-net.png": "142a",
	"./fish.png": "49a1",
	"./flatfish.png": "81ad",
	"./flour.png": "9339",
	"./fruits.png": "1014",
	"./gari.png": "b66d",
	"./herring.png": "3766",
	"./inside-out-maki.png": "cd3a",
	"./kitchen-supplies.png": "9997",
	"./lobster.png": "21a5",
	"./maki-2.png": "1b05",
	"./maki.png": "4ce9",
	"./material.png": "43f9",
	"./meat.png": "4e8c",
	"./miscellaneous.png": "c652",
	"./mochi.png": "51d9",
	"./nigiri-single.png": "6776",
	"./nigiri-various.png": "a828",
	"./noodle-bowl.png": "9e9e",
	"./noodles.png": "c812",
	"./octopus-2.png": "a5f6",
	"./octopus.png": "17b6",
	"./onigiri.png": "f95c",
	"./other.png": "189c",
	"./oyster.png": "cacc",
	"./poke-bowl.png": "6452",
	"./prawn.png": "50ed",
	"./qumo-2.png": "0e80",
	"./qumo.png": "0a6b",
	"./salmon.png": "1b9b",
	"./sardines.png": "b55e",
	"./sea-urchin.png": "1330",
	"./seaweed.png": "15a4",
	"./sesame.png": "0253",
	"./shrimp-2.png": "cb5f",
	"./shrimp-frozen.png": "0119",
	"./shrimp.png": "d56c",
	"./smoked-fish.png": "3dc3",
	"./smoked.png": "e819",
	"./snowflake.png": "db93",
	"./soya.png": "8b50",
	"./spices-and-pastes.png": "5d51",
	"./sushi.png": "3d55",
	"./tropical.png": "140f",
	"./tuna.png": "8c57",
	"./wasabi.png": "9deb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edd3";